/* eslint-disable array-callback-return */
import React, { useContext, useEffect, useRef  } from "react";
import CurrentUserContext from "../../Contexts/userContexts";
import "./PopUp.css";
export default function Modal(props) {

    const { onSelectCard } = props

    const { show, setShow, singlePlayer, select } = useContext(CurrentUserContext)
    let playerSelect

    singlePlayer.map(el => { if (el.player[0].idPlayer === select) { return (playerSelect = el.player[0]) } })

    const toggleModal = () => {
        setShow(!show)
    }

    if (show) {
        document.body.classList.add('active-modal')
    } else {
        document.body.classList.remove('active-modal')
    }


    let menuRef=useRef()
    useEffect(() => {
        const maybeHandler = (event) => {
            if (menuRef.current !== null && menuRef.current !==undefined && Object.keys(menuRef.current).length !== 0) {
                if (!menuRef.current.contains(event.target)) {
                   setShow(false);
               }
            }
        };
   
        document.addEventListener("mousedown", maybeHandler);
    
        return () => {
          document.removeEventListener("mousedown", maybeHandler);
        };
      });

    return (
        <>
            {show && (
                <div className="modal" >

                    <div
                        onClick={toggleModal}
                        className="overlay">
                    </div>
                    <div className="modal-content" ref={menuRef}>
                        <div className="allCard">
                            <div style={{ backgroundColor: `${playerSelect.strTeamColor}` }} className='playerCard'>
                                <div className='teamInformation'>
                                    <img className='teamBagde' src={playerSelect.strTeamBadge} alt={`${playerSelect.strPlayer} team bagde`} />
                                    {/* Equipa do jogador*/}
                                    <h2 className='playerTeam'>{playerSelect.strTeam}</h2>
                                </div>
                                <div className='playerInformation'>
                                    {/* imagem */}
                                    <img className='playerImage' src={playerSelect.strCutout} alt={`${playerSelect.strPlayer}`} />
                                    {/* nome do jogador */}
                                    {/* numero de jogador */}
                                    <div className='playerNumberDiv' style={{ backgroundColor: `${playerSelect.strTeamColor}` }}><h2 className='playerNumber'>{playerSelect.strNumber}</h2></div>
                                    {/* numero de jogador */}
                                    <h1 className='playerName'>{playerSelect.strPlayer}</h1>
                                    <div className='slideTwoCard'>
                                        <div className='slideTwoCardMore'>
                                            <div className="playerText">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="playerInfo">
                                <h1 className='text'>{playerSelect.strPlayer}</h1>
                                <ul>
                                    <li className="text">Nationality: {playerSelect.strNationality}</li>
                                    <li className="text">Team: {playerSelect.strTeam} - squad number: {playerSelect.strNumber}</li>
                                    <li className="text">Date of Birth: {playerSelect.dateBorn}</li>
                                    <li className="text">Position: {playerSelect.strPosition}</li>
                                    <li className="text">Height: {playerSelect.strHeight}</li>
                                    <li className="text">Weight: {playerSelect.strWeight}</li>
                                </ul>
                            </div>
                        </div>
                        <button
                            onClick={toggleModal}
                            className="close-modal">
                            Close
                        </button>
                        <button
                            onClick={() => onSelectCard(playerSelect)}
                            className="add-modal">
                            Add
                        </button>
                    </div>
                </div>
            )
            }
        </>
    )
}

